import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authApi } from "../../api/authApi";
import Navbar from "../../components/common/Layout/Navbar";

import "./Auth.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    try {
      const response = await authApi.forgotPassword(email);
      setMessage(
        response.message ||
          "Password reset instructions have been sent to your email.",
      );
      setEmail("");
    } catch (err) {
      setError(
        err.response?.data?.error || "Something went wrong. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar variant="auth" />
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Forgot Password</h1>
            <p>We'll send you instructions to reset your password</p>
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          {message && <div className="alert alert-success">{message}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
              />
            </div>

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? "Sending..." : "Send Instructions"}
            </button>
          </form>

          <div className="auth-footer">
            <p>
              <Link to="/login">Back to Sign In</Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
